import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Icon,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Button,
  TextField,
} from "@material-ui/core";
import { LOCALE } from "../../../properties/Locale";
import { useDispatch } from "react-redux";
import { changePageTitle } from "../../../common/actions/CommonActions";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import CardBody from "../../../common/components/Card/CardBody";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import { PieChart } from "react-minimal-pie-chart";
import moment from "moment";
import { ChartsRepository } from "./ChartsRepository";
import { VacancyRepository } from "../../vacancy/VacancyRepository";
import { VacancyAppRepository } from "../../vacancyApplication/VacancyAppRepository";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "../../../assets/fonts/times-normal";
import { DashboardRepository } from "../DashboardRepository";
import { AuthService } from "../../../auth/AuthService";
import { UsersRepository } from "../../administration/users/UsersRepository";

const colors = {
  DRAFT: "yellow",
  SUBMITTED: "green",
  ADDITIONAL_DATA_REQUIRED: "orange",
  COMMISION_EVAL: "blue",
  BRO_CSO_SCHOOL_EVAL: "lightblue",
  EVALUATED: "#B38652",
  REJECTED: "red",
  TEACHER_MENTOR: "#E38627",
  TEACHER_ADVISOR: "#C13C37",
  ASSOCIATE_MENTOR: "#9ca312",
  ASSOCIATE_ADVISOR: "#1f78ff",
  BUREAU_GRADING_PENDING: "#E38627",
  SCHOOL_GRADING_PENDING: "#C13C37",
  EDU_CENTER_GRADING_PENDING: "#9ca312",
  COMMISION_EVAL: "#1f78ff",
};

export default function ChartsComponent() {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [selected, setSelected] = useState(0);
  const [hovered, setHovered] = useState(0);
  const [dataMock, setDataMock] = useState([]);
  const [dataMock1, setDataMock1] = useState([]);
  const [dataMock2, setDataMock2] = useState([]);
  const [rerender, triggerRerender] = useState(false);
  const [vacancies, setVacancies] = useState();
  const [selectedVacancy, setSelectedVacancy] = useState("");
  const [vacancyApps, setVacancyApps] = useState();
  const [iframeUrl, setIFrameUrl] = useState();
  const [currentUser, setCurrentUser] = useState();

  React.useEffect(() => {
    dispatch(changePageTitle(LOCALE.dashboard));
    // getVacAppStatuses("");
    // getEvalPendingVacAppStatuses("");
    // countByType("");
    getCurrentUser();

    VacancyRepository.fetchAllVacancy({
      page: 0,
      size: 100,
      orderBy: "dateCreated",
      orderDirection: "DESC",
    }).then((res) => {
      setVacancies(res.data.content);
    });
  }, []);

  React.useEffect(() => {
    if (selectedVacancy?.id && currentUser) {
      if (auth.hasRole("ROLE_ADMINISTRATION")) {
        generateIFrameUrlAdmin(5);
      } else {
        generateIFrameUrlCommision(6, currentUser?.id);
        console.log(currentUser);
      }
    }
  }, [selectedVacancy, currentUser]);

  useEffect(() => {
    if (iframeUrl) {
      const timeout = setTimeout(() => {
        var iframe = document.getElementById("myframe");
        console.log(iframe);
        var links = document.getElementById("myframe").querySelectorAll("a");
        console.log(links);
        for (var i = 0; i < links.length; i++) {
          links[i].setAttribute("target", "_blank");
        }
      }, 2000);

      return () => clearTimeout(timeout);
    }
  }, [iframeUrl]);

  const auth = {
    hasRole: function (role) {
      var currentUser = JSON.parse(window.localStorage.getItem("currentUser"));
      for (var i = 0; i < currentUser.authorities.length; i++) {
        if (currentUser.authorities[i].authority == role) {
          return true;
        }
      }
    },
  };

  const getCurrentUser = () => {
    UsersRepository.fetchCurrentUserDetails().then((res) => {
      setCurrentUser(res.data);
    });
  };

  const onVacancyChange = (vacId) => {
    setSelectedVacancy(vacId);
    // getVacAppStatuses(vacId.id ? vacId.id : "");
    // getEvalPendingVacAppStatuses(vacId.id ? vacId.id : "");
    // countByType(vacId.id ? vacId.id : "");
    // getAllVacApps(0, 10, vacId.id);
  };

  const getAllVacApps = (page, size, vacId) => {
    VacancyAppRepository.getAll({
      page: page,
      size: size,
      filterBy: "vacancy",
      filterValue: vacId,
      orderBy: "totalPoints",
      orderDirection: "DESC",
    }).then((res) => {
      setVacancyApps(res.data.content);
    });
  };

  const getVacAppStatuses = (vacId) => {
    (async () => {
      let data = [];
      await ChartsRepository.getVacAppStatuses(vacId).then((res) => {
        let i = 0;
        res.data.forEach((element) => {
          if (element[1] > 0) {
            data.push({
              title: element[0],
              value: element[1],
              color: colors[element[0]],
            });
            i++;
          }
        });
      });
      setDataMock1(data);
    })();
  };

  const getEvalPendingVacAppStatuses = (vacId) => {
    (async () => {
      let data = [];
      await ChartsRepository.getEvalPendingVacAppStatuses(vacId).then((res) => {
        let i = 0;
        res.data.forEach((element) => {
          if (element[1] > 0) {
            data.push({
              title: element[0],
              value: element[1],
              color: colors[element[0]],
            });
            i++;
          }
        });
      });
      setDataMock2(data);
    })();
  };

  const countByType = (vacId) => {
    (async () => {
      let data = [];
      await ChartsRepository.countByType(vacId).then((res) => {
        let i = 0;
        res.data.forEach((element) => {
          if (element[1] > 0) {
            data.push({
              title: element[0],
              value: element[1],
              color: colors[element[0]],
            });
            i++;
          }
        });
      });
      setDataMock(data);
    })();
  };

  const exportPDF = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape
    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);
    const title = [LOCALE.login_h1, LOCALE.rank_list + selectedVacancy.name];
    const headers = [
      [
        LOCALE.created_by,
        LOCALE.school,
        LOCALE.submissionDate,
        LOCALE.professional_development_grading,
        LOCALE.bureau_grading,
        LOCALE.educational_center_grading,
        LOCALE.school_grading,
        LOCALE.total_points,
      ],
    ];

    (async () => {
      let data = [];
      await ChartsRepository.getRankingList(selectedVacancy.id).then((res) => {
        data = res.data.map((vacApp) => [
          vacApp.basicInfo?.firstName + " " + vacApp?.basicInfo?.lastName,
          vacApp.basicInfo?.school?.name,
          moment(vacApp.submissionDate).format("YYYY-MM-DD HH:mm:ss"),
          vacApp.professionalDevelopment?.points + 0,
          vacApp.bureauGrading?.points + 0,
          vacApp.educationalCenterGrading?.points + 0,
          vacApp.schoolGrading?.points + 0,
          vacApp.totalPoints + 0,
        ]);
      });
      let content = {
        startY: 70,
        head: headers,
        font: "times",
        theme: "grid",
        headStyles: {
          font: "times",
          fontStyle: "normal",
          halign: "center",
          fillColor: "#bde4d1",
          textColor: "#333333",
        },
        bodyStyles: {
          font: "times",
          fontStyle: "normal",
        },
        columnStyles: {
          3: { halign: "center" },
          4: { halign: "center" },
          5: { halign: "center" },
          6: { halign: "center" },
          7: { halign: "center" },
        },
        body: data,
      };

      doc.setFont("times");
      doc.setFontSize(15);
      doc.text(title, 430, 40, 0, 0, "center");
      doc.autoTable(content);
      doc.save(selectedVacancy.name + "_report.pdf");
    })();
  };

  const generateIFrameUrlAdmin = (dashboardId) => {
    // setIFrameUrl("TEST");
    DashboardRepository.generateToken({
      vacancyid: selectedVacancy?.id,
      dashboardId: dashboardId,
    }).then((res) => {
      console.log(res);
      setIFrameUrl(res.data);
    });
  };

  const generateIFrameUrlCommision = (dashboardId, assignedTo) => {
    // setIFrameUrl("TEST");
    DashboardRepository.generateToken({
      vacancyid: selectedVacancy?.id,
      dashboardId: dashboardId,
      assignedto: assignedTo,
    }).then((res) => {
      console.log(res);
      setIFrameUrl(res.data);
    });
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormControl
            className={classes.formControl}
            variant="outlined"
            size="small"
            fullWidth
          >
            <InputLabel id="demo-simple-select-label1">
              {LOCALE.choose_vacancy}
            </InputLabel>
            <Select
              labelId="demo-simple-select-label1"
              id="demo-simple-select1"
              label={LOCALE.choose_vacancy}
              value={selectedVacancy}
              onChange={(e) => onVacancyChange(e.target.value)}
            >
              <MenuItem key={"ALL"} value={{ id: "ALL" }}>
                {LOCALE.all}
              </MenuItem>
              {vacancies?.map((item, index) => (
                <MenuItem key={index} value={item}>
                  {`${item.name} (${LOCALE.getString(item?.vacancyType)})`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
      {/* <Grid container spacing={4}>
        <Grid item xs={4}>
          <Grid container>
            <Grid item xs={12}>
              <Card>
                <CardHeader color="theme">
                  <Typography>{LOCALE.submitted_apps}</Typography>
                </CardHeader>
                <CardBody>
                  {dataMock?.length > 0 ? (
                    <Grid container>
                      <Grid item xs={5}>
                        {dataMock?.map((element) => (
                          <Grid container>
                            <Grid item xs={2}>
                              <div
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  backgroundColor: element.color,
                                }}
                              ></div>
                            </Grid>
                            <Grid item xs={10}>
                              <Typography style={{ fontSize: "12px" }}>
                                {element.title === "TEACHER_MENTOR"
                                  ? "Наставник - Ментор"
                                  : element.title === "TEACHER_ADVISOR"
                                  ? "Наставник-Советник"
                                  : element.title === "ASSOCIATE_MENTOR"
                                  ? "Стручен Соработник-Ментор"
                                  : element.title === "ASSOCIATE_ADVISOR"
                                  ? "Стручен Соработник-Советник"
                                  : ""}
                              </Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                      <Grid item xs={7}>
                        <PieChart
                          data={dataMock}
                          lineWidth={20}
                          paddingAngle={18}
                          rounded
                          label={({ dataEntry }) => dataEntry.value}
                          labelStyle={(index) => ({
                            fill: dataMock[index].color,
                            fontSize: "5px",
                            fontFamily: "sans-serif",
                            fontWeight: "bold",
                          })}
                          labelPosition={60}
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid container>
                      <Grid item xs={2}></Grid>
                      <Grid item xs={8}>
                        <Typography component="span">
                          {" "}
                          <Icon
                            style={{
                              verticalAlign: "bottom",
                              color: "orange",
                            }}
                          >
                            warning
                          </Icon>{" "}
                          {LOCALE.no_data_for_analysis}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                  )}
                </CardBody>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid container>
            <Grid item xs={12}>
              <Card>
                <CardHeader color="theme">
                  <Typography>{LOCALE.apps_status}</Typography>
                </CardHeader>
                <CardBody>
                  {dataMock1?.length > 0 ? (
                    <Grid container>
                      <Grid item xs={5}>
                        {dataMock1?.map((element) => (
                          <Grid container>
                            <Grid item xs={2}>
                              <div
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  backgroundColor: element.color,
                                }}
                              ></div>
                            </Grid>
                            <Grid item xs={10}>
                              <Typography style={{ fontSize: "12px" }}>
                                {LOCALE.getString(element.title)}
                              </Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                      <Grid item xs={7}>
                        <PieChart
                          style={{
                            fontFamily:
                              '"Nunito Sans", -apple-system, Helvetica, Arial, sans-serif',
                            fontSize: "8px",
                          }}
                          data={dataMock1}
                          radius={PieChart.defaultProps.radius - 7}
                          lineWidth={60}
                          segmentsStyle={{
                            transition: "stroke .3s",
                            cursor: "pointer",
                          }}
                          segmentsShift={(index) =>
                            index === selected ? 7 : 1
                          }
                          animate
                          label={({ dataEntry }) =>
                            Math.round(dataEntry.percentage) + "%"
                          }
                          labelPosition={100 - 60 / 2}
                          labelStyle={{
                            fill: "#fff",
                            opacity: 0.75,
                            pointerEvents: "none",
                          }}
                          onClick={(_, index) => {
                            setSelected(index === selected ? undefined : index);
                          }}
                          onMouseOver={(_, index) => {
                            setHovered(index);
                          }}
                          onMouseOut={() => {
                            setHovered(undefined);
                          }}
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid container>
                      <Grid item xs={2}></Grid>
                      <Grid item xs={8}>
                        <Icon
                          style={{
                            verticalAlign: "bottom",
                            color: "orange",
                          }}
                        >
                          warning
                        </Icon>{" "}
                        <Typography component="span">
                          {LOCALE.no_data_for_analysis}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                  )}
                </CardBody>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid container>
            <Grid item xs={12}>
              <Card>
                <CardHeader color="theme">
                  <Typography>{LOCALE.pending_apps_for_eval}</Typography>
                </CardHeader>
                <CardBody>
                  {dataMock2.length > 0 ? (
                    <Grid container>
                      <Grid item xs={5}>
                        {dataMock2?.map((element) => (
                          <Grid container>
                            <Grid item xs={2}>
                              <div
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  backgroundColor: element.color,
                                }}
                              ></div>
                            </Grid>
                            <Grid item xs={10}>
                              <Typography style={{ fontSize: "12px" }}>
                                {element.title === "SUBMITTED"
                                  ? "Поднесени"
                                  : element.title === "ADDITIONAL_DATA_REQUIRED"
                                  ? "Дополнителни податоци"
                                  : element.title === "COMMISION_EVAL"
                                  ? "Оценување-Комисија"
                                  : element.title === "BRO_CSO_SCHOOL_EVAL"
                                  ? "Оценување-Советник"
                                  : element.title === "BUREAU_GRADING_PENDING"
                                  ? "Оценување-БРО"
                                  : element.title === "SCHOOL_GRADING_PENDING"
                                  ? "Оценување-Училиште"
                                  : element.title ===
                                    "EDU_CENTER_GRADING_PENDING"
                                  ? "Оценување-ЦСОО"
                                  : element.title === "EVALUATED"
                                  ? "Оценети"
                                  : element.title === "DRAFT"
                                  ? "Драфт"
                                  : ""}
                              </Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                      <Grid item xs={7}>
                        <PieChart
                          data={dataMock2}
                          radius={PieChart.defaultProps.radius - 7}
                          segmentsShift={(index) => (index === 0 ? 7 : 1)}
                          label={({ dataEntry }) => dataEntry.value}
                          labelStyle={{
                            fill: "#fff",
                            opacity: 0.75,
                            pointerEvents: "none",
                          }}
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid container>
                      <Grid item xs={2}></Grid>
                      <Grid item xs={8}>
                        <Icon
                          style={{
                            verticalAlign: "bottom",
                            color: "orange",
                          }}
                        >
                          warning
                        </Icon>{" "}
                        <Typography component="span">
                          {LOCALE.no_data_for_analysis}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                  )}
                </CardBody>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Card>
            <CardHeader color="theme">
              <Typography component="span">
                {LOCALE.all_applications}
              </Typography>
              <Button
                style={{ float: "right" }}
                variant="contained"
                size="small"
                color="primary"
                onClick={() => exportPDF()}
                disabled={!selectedVacancy}
              >
                {LOCALE.generate_rank_list}
              </Button>
            </CardHeader>
            <CardBody>
              <Table aria-label="users table" className={classes.table}>
                <TableHead>
                  <TableRow className={classes.tableHeadRow}>
                    <TableCell
                      style={{ fontWeight: "bold" }}
                      className={
                        classes.tableCell + " " + classes.tableHeadCell
                      }
                    >
                      {LOCALE.created_by}
                    </TableCell>
                    <TableCell
                      style={{ fontWeight: "bold" }}
                      className={
                        classes.tableCell + " " + classes.tableHeadCell
                      }
                    >
                      {LOCALE.school}
                    </TableCell>
                    <TableCell
                      style={{ fontWeight: "bold", textAlign: "center" }}
                      className={
                        classes.tableCell + " " + classes.tableHeadCell
                      }
                    >
                      {LOCALE.submissionDate}
                    </TableCell>
                    <TableCell
                      style={{ fontWeight: "bold", textAlign: "center" }}
                      className={
                        classes.tableCell + " " + classes.tableHeadCell
                      }
                    >
                      {LOCALE.status}
                    </TableCell>
                    <TableCell
                      style={{
                        width: "100px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                      className={
                        classes.tableCell + " " + classes.tableHeadCell
                      }
                    >
                      {LOCALE.professional_development_grading}
                    </TableCell>
                    <TableCell
                      style={{
                        width: "100px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                      className={
                        classes.tableCell + " " + classes.tableHeadCell
                      }
                    >
                      {LOCALE.bureau_grading}
                    </TableCell>
                    <TableCell
                      style={{
                        width: "100px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                      className={
                        classes.tableCell + " " + classes.tableHeadCell
                      }
                    >
                      {LOCALE.educational_center_grading}
                    </TableCell>
                    <TableCell
                      style={{
                        width: "100px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                      className={
                        classes.tableCell + " " + classes.tableHeadCell
                      }
                    >
                      {LOCALE.school_grading}
                    </TableCell>
                    <TableCell
                      className={
                        classes.tableCell + " " + classes.tableHeadCell
                      }
                      style={{
                        width: "100px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      {LOCALE.total_points}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {vacancyApps &&
                    vacancyApps.map((vacancyApp, index) => (
                      <TableRow
                        style={index % 2 === 1 ? { background: "#f0f0f0" } : {}}
                      >
                        <TableCell>
                          {vacancyApp?.basicInfo?.firstName +
                            " " +
                            vacancyApp?.basicInfo?.lastName}
                        </TableCell>
                        <TableCell>
                          {vacancyApp?.basicInfo?.school?.name}
                        </TableCell>

                        <TableCell style={{ textAlign: "center" }}>
                          {vacancyApp.submissionDate &&
                            moment(vacancyApp.submissionDate).format(
                              "YYYY-MM-DD HH:mm:ss"
                            )}
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          {vacancyApp.status &&
                            vacancyApp.status === "DRAFT" && (
                              <Chip
                                label={LOCALE.getString("DRAFT")}
                                style={{
                                  color: "white",
                                  backgroundColor: "orange",
                                }}
                              />
                            )}
                          {vacancyApp.status &&
                            vacancyApp.status === "SUBMITTED" && (
                              <Chip
                                label={LOCALE.getString("SUBMITTED")}
                                style={{
                                  color: "white",
                                  backgroundColor: "green",
                                }}
                              />
                            )}
                          {vacancyApp.status &&
                            vacancyApp.status ===
                              "ADDITIONAL_DATA_REQUIRED" && (
                              <Chip
                                label={LOCALE.getString(
                                  "ADDITIONAL_DATA_REQUIRED"
                                )}
                                style={{
                                  color: "white",
                                  backgroundColor: "orange",
                                }}
                              />
                            )}
                          {vacancyApp.status &&
                            vacancyApp.status === "COMMISION_EVAL" && (
                              <Chip
                                label={LOCALE.getString("COMMISION_EVAL")}
                                style={{
                                  color: "white",
                                  backgroundColor: "green",
                                }}
                              />
                            )}
                          {vacancyApp.status &&
                            vacancyApp.status === "BRO_CSO_SCHOOL_EVAL" && (
                              <Chip
                                label={LOCALE.getString("BRO_CSO_SCHOOL_EVAL")}
                                style={{
                                  color: "white",
                                  backgroundColor: "green",
                                }}
                              />
                            )}
                          {vacancyApp.status &&
                            vacancyApp.status === "EVALUATED" && (
                              <Chip
                                label={LOCALE.getString("EVALUATED")}
                                style={{
                                  color: "white",
                                  backgroundColor: "green",
                                }}
                              />
                            )}
                          {vacancyApp.status &&
                            vacancyApp.status === "REJECTED" && (
                              <Chip
                                label={LOCALE.getString("REJECTED")}
                                style={{
                                  color: "white",
                                  backgroundColor: "red",
                                }}
                              />
                            )}
                        </TableCell>
                        <TableCell>
                          <TextField
                            value={
                              vacancyApp.professionalDevelopment?.points + 0
                            }
                            disabled={true}
                          />
                        </TableCell>

                        <TableCell>
                          <TextField
                            value={vacancyApp.bureauGrading?.points + 0}
                            disabled={true}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            value={
                              vacancyApp.educationalCenterGrading?.points + 0
                            }
                            disabled={true}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            value={vacancyApp.schoolGrading?.points + 0}
                            disabled={true}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            value={
                              vacancyApp.totalPoints
                                ? vacancyApp.totalPoints
                                : 0
                            }
                            disabled={true}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </CardBody>
          </Card>
        </Grid>
      </Grid> */}
      <Grid container>
        <Grid item md={12}>
          {iframeUrl && (
            <>
              <iframe
                id="myframe"
                src={iframeUrl}
                frameborder="0"
                width="100%"
                height="100vh"
                style={{ height: "100vh" }}
                allowtransparency={true}
              ></iframe>
            </>
          )}
        </Grid>
      </Grid>
    </div>
  );
}
